var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useRef, useState } from "react";
import InputField from "@frameworks/web/components/generic/inputField";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import di from "../di/index";
import { password } from "../../../utils/regex";
import BackToLogin from "../common/BackToLogin";
import { ECurrentLoginComponent, EResetPasswordFlow, } from "@domains/salesFeatures/Login/entities/iLogin";
import { ERole } from "../Login";
import Loader from "../../../../shared-library/components/Loader";
import InputPasswordToggle from "../../../../shared-library/components/InputPasswordToggle";
import { useSelector } from "react-redux";
var ResetPassword = function (props) {
    var _a = props.showBackToLogin, showBackToLogin = _a === void 0 ? true : _a, _b = props.showHeader, showHeader = _b === void 0 ? true : _b;
    var _c = __read(useState({ newPassword: "", confirmPassword: "" }), 2), error = _c[0], setError = _c[1];
    var _d = __read(useState(""), 2), newPassword = _d[0], setNewPassword = _d[1];
    var _e = __read(useState(""), 2), reEnterNewPassword = _e[0], setReEnterNewPassword = _e[1];
    var _f = __read(useState(false), 2), initialRender = _f[0], setInitialRender = _f[1];
    var _g = __read(useState(""), 2), responseError = _g[0], setResponseError = _g[1];
    var _h = __read(useState(false), 2), showLoader = _h[0], setShowLoader = _h[1];
    var _j = __read(useState({
        toggleInputOne: true,
        toggleInputTwo: true,
    }), 2), passwordMask = _j[0], setPasswordMask = _j[1];
    var passwordInputRef = useRef(null);
    var reEnterPasswordInputRef = useRef(null);
    var extraConfig = useSelector(function (state) {
        return state.Login.LoginComponentReducer.reducersData.extraConfig;
    });
    var validationError = function (field, value) {
        var _a;
        setError(__assign(__assign({}, error), (_a = {}, _a[field] = value, _a)));
    };
    var resetPasswordData = function () {
        setShowLoader(true);
        var payload = {
            userName: props.partnerCode,
            loginFor: "partner",
            newPassword: newPassword,
            reenterNewPassword: reEnterNewPassword,
            validateotprequestDTO: {
                otp: extraConfig.OTPDetails.otp,
                otpId: extraConfig.OTPDetails.otpId,
            },
        };
        var reqPayload = {
            isForgotPassword: false,
            reqBody: payload,
        };
        if (!(props === null || props === void 0 ? void 0 : props.isChangePassword) &&
            !!extraConfig &&
            extraConfig.resetPasswordFlow === EResetPasswordFlow.FORGOT_RESET_PASSWORD) {
            reqPayload.isForgotPassword = true;
        }
        di.login
            .resetPassword(reqPayload)
            .then(function (resp) {
            if (resp) {
                setShowLoader(false);
                if (props === null || props === void 0 ? void 0 : props.isChangePassword) {
                    props === null || props === void 0 ? void 0 : props.changePasswordCallback();
                }
                else {
                    di.login.changeCurrentLoginComponent({
                        currentComponent: ECurrentLoginComponent.RM_PARTNER_LOGIN_TABS,
                        extraConfig: {
                            currentActiveTab: ERole.Partner,
                            tabMessage: resp.data,
                            messageIcon: (React.createElement("i", { className: "edel-icon-tick-color-circle" },
                                React.createElement("span", { className: "path1" }),
                                React.createElement("span", { className: "path2" }))),
                            tabMessageClass: "login-success-message",
                        },
                    });
                }
            }
        })
            .catch(function (error) {
            setShowLoader(false);
            setResponseError(error.getMessage());
        });
    };
    React.useEffect(function () {
        setInitialRender(true);
    }, []);
    return (React.createElement("div", { className: "d-flex flex-column justify-content-start align-items-center w-100 login-reset-password" },
        React.createElement("div", { className: "d-flex flex-column align-items-center justify-content-center" },
            showHeader && (React.createElement("div", { className: "txt-midnight-blue DMSan_24_700 reset-password-text taCenter" }, "Reset Your Password")),
            React.createElement(InputField, { value: newPassword, onChange: function (e) {
                    setInitialRender(false);
                    setNewPassword(e);
                }, pattern: password, onBlur: function (error, event) {
                    if (error.required)
                        validationError(event.target.name, "This field is Required");
                    else
                        validationError(event.target.name, "");
                }, placeholder: "Enter New Password", id: "newPassword", name: "newPassword", inputRef: passwordInputRef, autoComplete: "off", showLabel: false, placeholderClassName: "", className: "reset-input-field DMSanN_14_400 txt_secondary-gray  ".concat(newPassword.length > 0
                    ? newPassword.length >= 8 && newPassword.length <= 12
                        ? "green-colour-input"
                        : "red-colour-input"
                    : ""), errorText: error.newPassword, suffix: React.createElement("div", { className: "loader-password-toggle-container d-flex align-items-center" },
                    React.createElement(InputPasswordToggle, { isShowPassword: passwordMask.toggleInputOne, setIsShowPassword: function (value) {
                            setPasswordMask(__assign(__assign({}, passwordMask), { toggleInputOne: value }));
                        }, inputRef: passwordInputRef })), type: passwordMask.toggleInputOne ? "password" : "" }),
            React.createElement(InputField, { highlightInputField: true, placeholderClassName: "", className: "reset-input-field DMSanN_14_400 txt_secondary-gray  ".concat(reEnterNewPassword.length > 0 && newPassword.length > 0
                    ? reEnterNewPassword === newPassword &&
                        reEnterNewPassword.length >= 8 &&
                        reEnterNewPassword.length <= 12
                        ? "green-colour-input"
                        : "red-colour-input"
                    : ""), placeholder: "Re-enter New Password", inputRef: reEnterPasswordInputRef, value: reEnterNewPassword, onChange: function (e) {
                    setReEnterNewPassword(e);
                }, onBlur: function (error, event) {
                    if (error.required)
                        validationError(event.target.name, "This field is Required");
                    else
                        validationError(event.target.name, "");
                }, id: "confirmPassword", name: "confirmPassword", 
                // required={true}
                errorText: error.confirmPassword, suffix: React.createElement("div", { className: "loader-password-toggle-container d-flex align-items-center" },
                    React.createElement(InputPasswordToggle, { isShowPassword: passwordMask.toggleInputTwo, setIsShowPassword: function (value) {
                            setPasswordMask(__assign(__assign({}, passwordMask), { toggleInputTwo: value }));
                        }, inputRef: reEnterPasswordInputRef }),
                    showLoader && (React.createElement("div", { className: "input-loader-container" },
                        React.createElement(Loader, null)))), type: passwordMask.toggleInputTwo ? "password" : "" }),
            React.createElement(EdButton, { btnTyp: "midnight-blue", className: "reset-password-button", value: "Set New Password", onClick: function () {
                    resetPasswordData();
                }, disabled: newPassword.length >= 8 &&
                    newPassword.length <= 12 &&
                    newPassword === reEnterNewPassword &&
                    !showLoader
                    ? false
                    : true }),
            React.createElement("div", { className: " d-flex  DMSansNormal_12_400 bg_aqua_white pb-3 password-auth" },
                React.createElement("div", { className: "me-2 mt-1" },
                    initialRender && (React.createElement("i", { className: "edel-icon-Activation bg_aqua_white" })),
                    newPassword.length >= 8 && newPassword.length <= 12 ? (React.createElement("i", { className: "edel-icon-green-tick1 bg_aqua_white" })) : (!initialRender && (React.createElement("i", { className: "edel-icon-rounded-close txt_bloodRed" })))),
                React.createElement("div", null, "Password should be minimum 8 and not more than 12 characters long")),
            newPassword.length !== 0 &&
                reEnterNewPassword.length !== 0 &&
                newPassword !== reEnterNewPassword && (React.createElement("div", { className: " d-flex  DMSansNormal_12_400 bg_aqua_white password-auth pb-3 pt-0" },
                React.createElement("div", { className: "me-2 " },
                    React.createElement("i", { className: "edel-icon-rounded-close txt_bloodRed" })),
                React.createElement("div", null, "Passwords do not match "))),
            responseError && (React.createElement("div", { className: "mgt-15 login-error-message tab-header" }, responseError))),
        showBackToLogin && React.createElement(BackToLogin, null)));
};
export default ResetPassword;
